import React, { useEffect, useState } from "react";
import Select from 'react-select'
import { customSelectStyles } from "./sharedUtils";
import PlaceAutocompleteForm from "./PlaceAutocompleForm";
import MapPinForm from "./MapPinForm";

const FormAddress = (props) => {
  const { values, handleChange, handleBlur, errors, touched, setValues, setFieldValue } =
    props;
  const [regions, setRegions] = useState([]);
  const fetchRegions = async () => {
    const resp = await fetch('/suggestions/regions.json');
    const data = await resp.json()
    console.log('dd', data.resources);
    setRegions(data.resources);
  }    
  const handlePinChange = (e) => {
    setValues({
      ...values,
      lat: e.lat,
      lng: e.lng 
    })
  };
  
  const handleSuggestion = (e) => {
    setValues((currentValues) => ({
      ...currentValues,
      google_place_id: e.place_id ? e.place_id : currentValues.google_place_id,
      full_address: e.full_address,
      address_1: e.address_1,
      address_2: e.address_2,
      city: e.city,
      state: e.state,
      zipcode: e.zipcode,
      country: e.country,
      lat: e.lat,
      lng: e.lng
    }))
   
  }

  useEffect(() => {
    fetchRegions();
  }, []);

  const regionOptions = regions.map((cat) => ({label: cat.name, value: cat.id}));
  console.log('role', props)
  return (
    <React.Fragment>
      <div className="add_utf_listing_section margin-top-45">
        <div className="utf_add_listing_part_headline_part">
          <h3>
            <i className="sl sl-icon-map"></i>Location
          </h3>
        </div>
        <div className="utf_submit_section">
          <PlaceAutocompleteForm 
            onAutoFill={handleSuggestion}
          />
          <div className="row with-forms">
            <div className="col-md-6">
              <h5>Full Address
                <sup className="required">*</sup>
              </h5>
              <input
                type="text"
                name="full_address"
                id="full_address"
                required={true}
                placeholder="Address"
                autoComplete="full-address"
                value={`${values.full_address || ''}`}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  errors.full_address && touched.full_address
                    ? "form-input error"
                    : "form-input"
                }
              />
            </div>
            <div className="col-md-6">
              <h5>Region
                <sup className="required">*</sup>
              </h5>
              <Select 
                styles={customSelectStyles}
                className="react-select-wrapper"
                classNamePrefix="react-select"
                options={regionOptions} 
                name="categories"
                required={true}
                value={regionOptions.find((cat) => (cat.value === values.region_id))}
                onChange={e => {return setFieldValue('region_id', e ? e.value : null)}}
              />   
             
            </div>
            </div>
            <div className="row with-forms">

            <div className="col-md-6">
              <h5>Phone</h5>
              <input
                type="text"
                name="phone"
                id="phone"
                placeholder="Phone"
                value={`${values.phone || ''}`}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  errors.phone && touched.phone
                    ? "form-input error"
                    : "form-input"
                }
              />
            </div>
            <div className="col-md-6">
              <h5>Email</h5>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Email"
                value={`${values.email || ''}`}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  errors.email && touched.email
                    ? "form-input error"
                    : "form-input"
                }
              />
            </div>
            <div className="col-md-6">
              <h5>Website</h5>
              <input
                type="text"
                name="website"
                id="website"
                placeholder="Website"
                value={`${values.website || ''}`}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  errors.website && touched.website
                    ? "form-input error"
                    : "form-input"
                }
              />
            </div>

            <div className="col-md-6">
              <h5>Price description</h5>
              <input
                type="text"
                name="short_price"
                id="short_price"
                placeholder="Price description"
                value={`${values.short_price || ''}`}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  errors.short_price && touched.short_price
                    ? "form-input error"
                    : "form-input"
                }
              />
            </div>

            
             <div className="col-md-6" style={{display:  props.userRole === 'admin'  ? '' : 'none' }}>
              <h5>Google Place ID <a target="_blank" href="https://developers.google.com/maps/documentation/places/web-service/place-id">(more details)</a>
              </h5>
              <input
                type="text"
                name="google_place_id"
                id="google_place_id"
                placeholder="Google Place ID"
                value={`${values.google_place_id || ''}`}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  errors.google_place_id && touched.google_place_id
                    ? "form-input error"
                    : "form-input"
                }
              />
            </div>
            
             <div className="col-md-12" style={{display:  props.userRole === 'admin'  ? '' : 'none' }}>
              <h5>Google Map URL <a target="_blank" href="https://www.google.com/maps/place/">(review url of the listing)</a>
              </h5>
              <input
                type="text"
                name="gmap_url"
                id="gmap_url"
                placeholder="Google map url"
                value={`${values.gmap_url || ''}`}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  errors.gmap_url && touched.gmap_url
                    ? "form-input error"
                    : "form-input"
                }
              />
            </div>
            
            
            <div className="col-md-12">
              <h5>Geo location 
                (drag-drop marker on map below or use auto-populating information)
              <sup className="required">*</sup>
              </h5>
              <div className="row with-forms" style={{display: 'none'}}>
                <div className="col-md-6">
                  <input
                    type="number"
                    name="lat"
                    id="lat"
                    required={true}
                    placeholder="40.7324319"
                    value={`${values.lat || ''}`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      errors.lat && touched.lat
                        ? "input-text error"
                        : "input-text"
                    }
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="number"
                    name="lng"
                    id="lng"
                    required={true}
                    placeholder="-73.824807777775"
                    value={`${values.lng || ''}`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      errors.lng && touched.lng
                        ? "search-field error"
                        : "search-field"
                    }
                  />
                </div>
              </div>
            </div>

            <div
              id="utf_listing_location"
              className="col-md-12 utf_listing_section"
            >
              <MapPinForm
                locationData={{ lng: values.lng, lat: values.lat }}
                onChange={handlePinChange}
                gmapApiKey={`AIzaSyDjSoEQ_AnRmjr3NG3HPiaiT8ssOSkIFig`}
              />
             
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormAddress;
